export const USER_SAVE_TOKEN = 'saveUserToken';
export const USER_SAVE_PROFILE = 'saveUserProfile';
export const USER_SET_OPTION = 'setUserOption'
export const USER_SET_ROUTE_OPTION = 'setUserRouteOption'
export const USER_WIPE = 'wipeUser';

